import * as Immutable from "immutable";
import generateObjectId from "logic/generateObjectId";
import Query from "../queries/Query";
import Parameter from "../parameters/Parameter";
export default class Search {
  constructor(id, queries, parameters) {
    this._value = { id, queries: Immutable.OrderedSet(queries), parameters: Immutable.Set(parameters) };
  }
  static create() {
    return new Builder().newId().queries([]).parameters([]).build();
  }
  get id() {
    return this._value.id;
  }
  get queries() {
    return this._value.queries;
  }
  get parameters() {
    return this._value.parameters;
  }
  get requiredParameters() {
    return this.parameters.filter((p) => !p.defaultValue && !p.optional && p.needsBinding).toSet();
  }
  toBuilder() {
    const { id, queries, parameters } = this._value;
    return new Builder(Immutable.Map({ id, queries, parameters }));
  }
  toJSON() {
    const { id, queries, parameters } = this._value;
    return {
      id,
      queries: queries.toJS(),
      parameters: parameters.toJS()
    };
  }
  static fromJSON(value) {
    const { id, parameters } = value;
    const queries = value.queries.map((q) => Query.fromJSON(q));
    return new Search(
      id,
      queries,
      parameters.map((p) => Parameter.fromJSON(p))
    );
  }
  static builder() {
    return new Builder();
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  id(value) {
    return new Builder(this.value.set("id", value));
  }
  newId() {
    return this.id(generateObjectId());
  }
  queries(value) {
    return new Builder(this.value.set("queries", value));
  }
  parameters(value) {
    return new Builder(this.value.set("parameters", value));
  }
  build() {
    const { id, queries, parameters } = this.value.toObject();
    return new Search(id, queries, parameters);
  }
}
